import Component from '@glimmer/component';

import { service } from '@ember/service';
import LinksTo from 'ember-route-state/components/links-to.gjs';

export default class TimeSeriesSelectionMaxLocationsComponent extends Component {
  @service('time-series/selected-locations') selectedLocations;

  <template>
    {{#if this.selectedLocations.hasExcessLocations}}
      <div class="c-error">
        Locations exceed the maximum. Only {{this.selectedLocations.maxSelectedLocations}}
        locations will appear below. Remove excess location selections from the
        <LinksTo @route="time-series.search">search</LinksTo> page.
      </div>
    {{/if}}
  </template>
}
